import { useEffect, useCallback, useState } from 'react'
import { useConfigQuery } from 'src/app/zoomSdkQueries'
import { OnRunningContextChangeEvent, RunningContext } from 'src/types/sdk'
import { addErrorSDKToast } from 'src/utils/helpers'

export const useGetRunningContext = () => {
  const { isLoading, data, refetch } = useConfigQuery('config')
  const [runningContext, setRunningContext] = useState<RunningContext>()

  // set it from the config
  useEffect(() => {
    if (data?.runningContext) setRunningContext(data?.runningContext)
  }, [data?.runningContext])

  // set it when it changes
  const fn = useCallback(
    ({ runningContext }: OnRunningContextChangeEvent) => {
      setRunningContext(runningContext)
      // if we were previously within the main client and are now within a meeting
      // refetch config to get the meeting events working
      if (
        data?.runningContext === 'inMainClient' &&
        runningContext === 'inMeeting'
      ) {
        refetch()
      }
    },
    [data?.runningContext, refetch]
  )

  useEffect(() => {
    // prevent zoomSdk warning
    if (data) {
      try {
        window.zoomSdk.addEventListener('onRunningContextChange', fn)
      } catch {
        addErrorSDKToast('Error: cannot add onRunningContextChange event')
      }
    }

    return () => {
      if (data) window.zoomSdk.removeEventListener('onRunningContextChange', fn)
    }
  }, [fn, data])

  return { isLoading, runningContext }
}
